module.exports = __webpack_public_path__ + "static/media/HECO.738bc5ea.png";